/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9zZXR0aW5nLWFkbWluL3NldHRpbmctYWRtaW4uY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2h0bWwvTXlEZXNpZ25WMy9odG1sL3NyYy9hcHAvYWRtaW4vc2V0dGluZy1hZG1pbi9zZXR0aW5nLWFkbWluLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/setting-admin/setting-admin.component.css.shim.ngstyle.ts